import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const PDFSection = () => {
  const { t } = useLanguage();
  
  const pdfPath = './images/viola_svansele groent_ohneD.pdf';

  return (
    <section className="py-16 px-4 bg-gray-50">
      <div className="max-w-6xl mx-auto">
        <div className="bg-white rounded-lg shadow-lg p-8">
          <h2 className="text-3xl font-bold text-green-800 mb-6 text-center">
            {t('pdfSection.title')}
          </h2>
          
          {/* PDF Viewer */}
          <div className="mb-8">
            <div className="w-full" style={{ height: '600px' }}>
              <iframe
                src={pdfPath}
                className="w-full h-full border-2 border-gray-300 rounded"
                title="Viola Svansele Grönt PDF"
              />
            </div>
          </div>

          {/* Download Button */}
          <div className="text-center">
            <a
              href={pdfPath}
              download="viola_svansele_groent.pdf"
              className="inline-flex items-center px-6 py-3 bg-green-600 text-white font-semibold rounded-lg hover:bg-green-700 transition-colors duration-300 shadow-md hover:shadow-lg"
            >
              <svg
                className="w-5 h-5 mr-2"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                />
              </svg>
              {t('pdfSection.downloadPDF')}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PDFSection;
